import type { IntentTemplate } from "../types";
import { formatCountSummary, getArrayLength } from "./shared";

export const APPOINTMENTS_INTENT_TEMPLATES = {
  CREATE_APPOINTMENT: {
    label: "Appointment",
    pendingTitle: "Review New Appointment",
    summary: (payload) => {
      const count = getArrayLength(payload.serviceSelections);
      if (typeof payload.startTime === "string") {
        return `New appointment will be booked at ${payload.startTime}.`;
      }
      if (count !== undefined) {
        return `New appointment will be booked with ${count} service${count === 1 ? "" : "s"}.`;
      }
      return "New appointment will be booked.";
    },
    fieldLabels: {
      customerId: "Customer",
      startTime: "Start Time",
      serviceSelections: "Services",
      notes: "Notes",
      internalNotes: "Internal Notes",
      customerMessage: "Customer Message",
    },
  },
  UPDATE_APPOINTMENT: {
    label: "Appointment",
    pendingTitle: "Review Appointment Update",
    summary: () => "Appointment details will be updated.",
    fieldLabels: {
      appointmentId: "Appointment",
      startTime: "Start Time",
      bookingStatus: "Booking Status",
      outcome: "Outcome",
      notes: "Notes",
      internalNotes: "Internal Notes",
    },
  },
  BATCH_UPDATE_APPOINTMENTS: {
    label: "Appointments",
    pendingTitle: "Review Batch Appointment Updates",
    summary: (payload) =>
      formatCountSummary(getArrayLength(payload.appointmentIds), "appointment", "appointments"),
    fieldLabels: {
      appointmentIds: "Appointments",
      startTime: "Start Time",
      bookingStatus: "Booking Status",
      outcome: "Outcome",
      notes: "Notes",
      internalNotes: "Internal Notes",
    },
  },
  UPDATE_APPOINTMENT_STATUS: {
    label: "Appointment",
    pendingTitle: "Review Status Change",
    summary: (payload) => {
      const action = typeof payload.action === "string" ? payload.action : "update";
      if (action === "cancel") {
        return "Appointment will be cancelled.";
      }
      if (action === "complete") {
        return "Appointment will be marked as completed.";
      }
      return "Appointment status will be updated.";
    },
    fieldLabels: {
      appointmentId: "Appointment",
      action: "Action",
      cancellationReasonType: "Cancellation Reason",
      cancellationReasonText: "Cancellation Details",
    },
  },
  ASSIGN_APPOINTMENT_WORKER: {
    label: "Appointment",
    pendingTitle: "Review Worker Assignment",
    summary: () => "Assigned worker for an appointment service will be updated.",
    fieldLabels: {
      appointmentId: "Appointment",
      appointmentServiceId: "Appointment Service",
      workerId: "Worker",
    },
  },
} satisfies Record<string, IntentTemplate>;
